export default __webpack_public_path__ + "static/hq13-238e1a3a2aa062769a2d3d1fe01272ed.jpg";